import { Link } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { NotificheBell } from "../notifiche/NotificheBell";
import { LegaMenu } from "./LegaMenu";
import { adminAppVisibili, adminLegaVisibili } from "./adminLinks";
import { AvatarUtente } from "../profilo/AvatarUtente";
import { LogoApp } from "../common/LogoApp";
import { tr } from "../../i18n";

/**
 * Header desktop (visibile solo da md breakpoint in su):
 * - a sinistra il nome della lega corrente con la freccetta per cambiarla
 *   (Andrea 2026-09-14: al posto della scritta FantaSquad, che c'e' gia'
 *   nel logo)
 * - Logo grande centrato (icon-white-192.png con corona/scudo)
 * - "Benvenuto, Nome" + bell + avatar (profilo) + ⚙ Admin (gestione) + logout
 */
export function DesktopHeader() {
  const { user, logout } = useAuth();
  const firstName = user?.nome_completo?.trim().split(" ")[0] ?? tr("Utente");
  // Andrea 2026-09-29: su desktop la Gestione (Admin Lega / Admin App) si apre
  // da qui, non solo dalla card in home.
  const haGestione = adminLegaVisibili(user).length + adminAppVisibili(user).length > 0;

  return (
    <header className="bg-primary-deep border-b border-primary/30">
      <div className="max-w-7xl mx-auto px-6 py-3 grid grid-cols-[1fr_auto_1fr] items-center gap-4">
        {/* Lega corrente + cambio lega */}
        <LegaMenu variante="desktop" />

        {/* Logo center (più grande) */}
        <Link to="/" className="flex items-center">
          <LogoApp className="w-24 h-24 drop-shadow-[0_0_16px_rgba(212,175,55,0.5)]" />
        </Link>

        {/* User info right */}
        <div className="flex items-center gap-3 justify-end">
          <NotificheBell />
          <div className="text-fg text-sm">
            <span className="text-fg-muted">{tr("Benvenuto, ")}</span>
            <span className="text-accent font-bold italic">{firstName}</span>
          </div>
          <Link
            to="/profilo"
            title={tr("Il tuo profilo")}
            aria-label={tr("Profilo")}
            className="rounded-full hover:ring-2 hover:ring-accent/60 transition"
          >
            <AvatarUtente user={user} size={36} />
          </Link>
          {haGestione && (
            <Link
              to="/gestione"
              className="h-9 px-3 rounded-full bg-primary hover:bg-primary-soft text-fg text-xs font-bold tracking-wide transition flex items-center gap-1.5"
              title={tr("Gestione: Admin Lega e Admin App")}
            >
              <span aria-hidden>⚙</span> {tr("Admin")}
            </Link>
          )}
          <button
            onClick={logout}
            className="w-9 h-9 rounded-full bg-primary hover:bg-primary-soft text-fg transition flex items-center justify-center"
            title={tr("{{nome}} — esci", { nome: user?.nome_completo })}
            aria-label={tr("Logout")}
          >
            {/* Icona log-out (Lucide) */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-4 h-4"
              aria-hidden
            >
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
}
